/** @jsxImportSource @emotion/react */
import classNames from 'classnames';
import { Formik, FormikConfig, FormikProps } from 'formik';
import _ from 'lodash';
import templateNameValidator from 'modules/template-editor/domain/validators/template-name-validator';
import { modalButton, modalError, modalInputStyle } from 'modules/template-editor/ui/components/elements/modals/styles';
import React from 'react';
import UDFormInput from 'ud-form/components/input';
import { Button } from 'ud-ui/components/button/styles';
import Modal from 'ud-ui/components/modal';
import * as yup from 'yup';

export type MediaManagerTemplateFormValues = {
  name: string;
};

type Props = FormikConfig<MediaManagerTemplateFormValues> & {
  existingNames: string[];
  isLoading: boolean;
  submitLabel?: string;
};

const validator = (existingNames: string[]) =>
  yup.object({
    name: yup
      .string()
      .transform((val) => (typeof val === 'string' ? val.trim() : val))
      .test('media-manager-template-name', 'Invalid name', function (value) {
        const error = templateNameValidator(value ?? '', existingNames);
        if (error) {
          return this.createError({ message: error });
        }
        return true;
      }),
  });

function MediaManagerTemplateForm(props: Props) {
  const { existingNames, isLoading, submitLabel = 'Создать', ...rest } = props;

  const getErrors = (formProps: FormikProps<MediaManagerTemplateFormValues>) => {
    return _.find(formProps.errors, (error, key) => !!error && !!formProps.touched[key as keyof MediaManagerTemplateFormValues]);
  };

  return (
    <Formik validateOnChange validationSchema={validator(existingNames)} {...rest}>
      {(formProps) => (
        <form onSubmit={formProps.handleSubmit} className="w-[450px]">
          <Modal.Body className="flex flex-col gap-5">
            <UDFormInput
              readOnly={isLoading}
              onChangeCapture={() => {
                formProps.values.name && !formProps.touched.name && formProps.setFieldTouched('name');
              }}
              name="name"
              autoFocus
              css={modalInputStyle}
              placeholder="Название шаблона"
            />
          </Modal.Body>
          <Modal.Footer justify="start">
            <Button
              type="submit"
              className={classNames('flex-center', isLoading && 'loading')}
              disabled={!formProps.isValid || formProps.values.name.trim() === '' || isLoading}
              css={modalButton}
            >
              {submitLabel}
            </Button>
            <span css={modalError}>{getErrors(formProps)}</span>
          </Modal.Footer>
        </form>
      )}
    </Formik>
  );
}

export default MediaManagerTemplateForm;
